import { http } from '@/config/http'

export function setLoginPassword(data) {
    return http.post( '/users/login_password', data)
}

export function storeFeedback(data) {
    return http.post( '/feedbacks', data)
}
